import { configureStore } from "@reduxjs/toolkit"
import homeReducer from "./homeSlice"
import intlReducer from "./intlSlice"

export default configureStore({
  reducer: {
    home: homeReducer,
    intl: intlReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
})
